/* eslint-disable */
// @ts-nocheck
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Array: any;
  JsonArgument: any;
};

export type AssetContainer = {
  handle: Scalars['String'];
  title: Scalars['String'];
};

export type AssetInterface = {
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Asset_Slike = AssetInterface & {
  alt?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  container: AssetContainer;
  edit_url?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  focus_css?: Maybe<Scalars['String']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  is_audio?: Maybe<Scalars['Boolean']>;
  is_image?: Maybe<Scalars['Boolean']>;
  is_video?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  orientation?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  permalink?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['String']>;
  size_b?: Maybe<Scalars['Int']>;
  size_bytes?: Maybe<Scalars['Int']>;
  size_gb?: Maybe<Scalars['Float']>;
  size_gigabytes?: Maybe<Scalars['Float']>;
  size_kb?: Maybe<Scalars['Float']>;
  size_kilobytes?: Maybe<Scalars['Float']>;
  size_mb?: Maybe<Scalars['Float']>;
  size_megabytes?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type BardText = {
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Code = {
  code: Scalars['String'];
  mode: Scalars['String'];
};

export type Collection = {
  handle: Scalars['String'];
  structure?: Maybe<CollectionStructure>;
  title: Scalars['String'];
};

export type CollectionStructure = {
  expects_root: Scalars['Boolean'];
  handle: Scalars['String'];
  max_depth?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  tree?: Maybe<Array<Maybe<CollectionTreeBranch>>>;
};


export type CollectionStructureTreeArgs = {
  site?: InputMaybe<Scalars['String']>;
};

export type CollectionTreeBranch = {
  children?: Maybe<Array<Maybe<CollectionTreeBranch>>>;
  depth: Scalars['Int'];
  entry?: Maybe<EntryInterface>;
  /** @deprecated Replaced by `entry` */
  page?: Maybe<EntryInterface>;
};

export type DateRange = {
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};


export type DateRangeEndArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type DateRangeStartArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type EntryInterface = {
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type EntryInterfaceDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type EntryInterfaceLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type EntryInterfacePagination = {
  /** Current page of the cursor */
  current_page: Scalars['Int'];
  /** List of items on the current page */
  data?: Maybe<Array<Maybe<EntryInterface>>>;
  /** Number of the first item returned */
  from?: Maybe<Scalars['Int']>;
  /** Determines if cursor has more pages after the current page */
  has_more_pages: Scalars['Boolean'];
  /** The last page (number of pages) */
  last_page: Scalars['Int'];
  /** Number of items returned per page */
  per_page: Scalars['Int'];
  /** Number of the last item returned */
  to?: Maybe<Scalars['Int']>;
  /** Number of total items selected by the query */
  total: Scalars['Int'];
};

export type Entry_Messages_Message = EntryInterface & {
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  content?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  users_field?: Maybe<Array<Maybe<User>>>;
};


export type Entry_Messages_MessageContentArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Messages_MessageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Messages_MessageLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_News_News = EntryInterface & {
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  date?: Maybe<Scalars['String']>;
  detail_image?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<AssetInterface>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  news_url?: Maybe<Scalars['String']>;
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  read_more_text?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};


export type Entry_News_NewsDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_News_NewsLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Entry_Places_Place = EntryInterface & {
  CRM_AccountId?: Maybe<Scalars['String']>;
  CRMid?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  FunctionaLoc_code?: Maybe<Scalars['String']>;
  FunctionalLoc?: Maybe<Scalars['String']>;
  NAVid?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Street1?: Maybe<Scalars['String']>;
  blueprint?: Maybe<Scalars['String']>;
  collection: Collection;
  contracts?: Maybe<Array<Maybe<Contract>>>;
  counters?: Maybe<Array<Maybe<Counter>>>;
  date?: Maybe<Scalars['String']>;
  edit_url: Scalars['String'];
  external_document_number?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceNotifications?: Maybe<Scalars['Boolean']>;
  last_modified?: Maybe<Scalars['String']>;
  locale: Scalars['String'];
  names?: Maybe<Array<Maybe<Sets_Names>>>;
  parent?: Maybe<EntryInterface>;
  permalink?: Maybe<Scalars['String']>;
  private: Scalars['Boolean'];
  published: Scalars['Boolean'];
  recipient_number?: Maybe<Scalars['String']>;
  site: Site;
  slug: Scalars['String'];
  status: Scalars['String'];
  tax_number?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  users_field?: Maybe<Array<Maybe<User>>>;
};


export type Entry_Places_PlaceContractsArgs = {
  id?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type Entry_Places_PlaceCountersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type Entry_Places_PlaceDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};


export type Entry_Places_PlaceLast_ModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Field = {
  config?: Maybe<Scalars['Array']>;
  display: Scalars['String'];
  handle: Scalars['String'];
  instructions?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type Form = {
  fields?: Maybe<Array<Maybe<Field>>>;
  handle: Scalars['String'];
  honeypot?: Maybe<Scalars['String']>;
  rules?: Maybe<Scalars['Array']>;
  title: Scalars['String'];
};

export type GlobalSetInterface = {
  handle: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_Admin = GlobalSetInterface & {
  end_date_counter?: Maybe<Scalars['Int']>;
  handle: Scalars['String'];
  site: Site;
  start_date_counter?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type GlobalSet_Faq = GlobalSetInterface & {
  handle: Scalars['String'];
  questions?: Maybe<Array<Maybe<Sets_Questions>>>;
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_Forms = GlobalSetInterface & {
  forms_type?: Maybe<Array<Maybe<Sets_FormsType>>>;
  handle: Scalars['String'];
  site: Site;
  title: Scalars['String'];
};

export type GlobalSet_Translations = GlobalSetInterface & {
  add_more_bard_fields_here_and_you_ll_see_them_in_graphql?: Maybe<Scalars['String']>;
  cookies?: Maybe<Scalars['String']>;
  handle: Scalars['String'];
  privacy_policy?: Maybe<Scalars['String']>;
  read_more_text?: Maybe<Scalars['String']>;
  site: Site;
  terms_and_conditions?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type LabeledValue = {
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type NavTreeBranch = {
  children?: Maybe<Array<Maybe<NavTreeBranch>>>;
  depth: Scalars['Int'];
  page?: Maybe<PageInterface>;
};

export type Navigation = {
  expects_root: Scalars['Boolean'];
  handle: Scalars['String'];
  max_depth?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  tree?: Maybe<Array<Maybe<NavTreeBranch>>>;
};


export type NavigationTreeArgs = {
  site?: InputMaybe<Scalars['String']>;
};

export type PageInterface = {
  entry_id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Query = {
  counter_entered?: Maybe<Counter_Entered>;
  counter_number?: Maybe<Counter_Number>;
  counter_query?: Maybe<Counter_Query>;
  create_counter?: Maybe<Create_Counter>;
  create_place?: Maybe<Create_Place>;
  create_task?: Maybe<Create_Task>;
  edit_place?: Maybe<Edit_Place>;
  entry?: Maybe<EntryInterfacePagination>;
  global_admin?: Maybe<GlobalSetInterface>;
  ping?: Maybe<Scalars['String']>;
  place_balance?: Maybe<Place_Balance>;
  receipt?: Maybe<Receipt>;
  receipt_pdf?: Maybe<Receipt_Pdf>;
  remove_place?: Maybe<Remove_Place>;
  statistics?: Maybe<Statistics>;
};


export type QueryCounter_EnteredArgs = {
  place_id?: InputMaybe<Scalars['String']>;
};


export type QueryCounter_NumberArgs = {
  place_id?: InputMaybe<Scalars['String']>;
};


export type QueryCounter_QueryArgs = {
  place_id?: InputMaybe<Scalars['String']>;
};


export type QueryCreate_CounterArgs = {
  counter_number?: InputMaybe<Scalars['String']>;
  counter_type?: InputMaybe<Scalars['String']>;
  place_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};


export type QueryCreate_PlaceArgs = {
  external_document_number?: InputMaybe<Scalars['String']>;
  recipient_number?: InputMaybe<Scalars['String']>;
  tax_number?: InputMaybe<Scalars['String']>;
};


export type QueryCreate_TaskArgs = {
  body?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryEdit_PlaceArgs = {
  id?: InputMaybe<Scalars['String']>;
  invoiceNotifications?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};


export type QueryEntryArgs = {
  filter?: InputMaybe<Scalars['JsonArgument']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryGlobal_AdminArgs = {
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPlace_BalanceArgs = {
  place_id?: InputMaybe<Scalars['String']>;
};


export type QueryReceiptArgs = {
  customer_num?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
};


export type QueryReceipt_PdfArgs = {
  cust_ledger_entry?: InputMaybe<Scalars['String']>;
  place_id?: InputMaybe<Scalars['String']>;
};


export type QueryRemove_PlaceArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryStatisticsArgs = {
  customer_num?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type Role = {
  handle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Set_Counters_NovKomplet = {
  counter_value?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type Set_Counters_NovKompletMonthArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type Set_FormsType_NovKomplet = {
  form_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Set_Names_NovKomplet = {
  custom_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  user?: Maybe<User>;
};

export type Set_Questions_NovKomplet = {
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Sets_AddMoreBardFieldsHereAndYouLlSeeThemInGraphql = BardText;

export type Sets_Cookies = BardText;

export type Sets_Counters = Set_Counters_NovKomplet;

export type Sets_FormsType = Set_FormsType_NovKomplet;

export type Sets_Names = Set_Names_NovKomplet;

export type Sets_PrivacyPolicy = BardText;

export type Sets_Questions = Set_Questions_NovKomplet;

export type Sets_Questions_Answer = BardText;

export type Sets_TermsAndConditions = BardText;

export type Site = {
  handle: Scalars['String'];
  locale: Scalars['String'];
  name: Scalars['String'];
  short_locale: Scalars['String'];
  url: Scalars['String'];
};

export type TableRow = {
  cells?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Taxonomy = {
  handle: Scalars['String'];
  title: Scalars['String'];
};

export type TermInterface = {
  edit_url: Scalars['String'];
  id: Scalars['ID'];
  permalink?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  taxonomy: Taxonomy;
  title: Scalars['String'];
  uri?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type User = {
  crm_id?: Maybe<Scalars['String']>;
  edit_url?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_verified_at?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<UserGroup>>>;
  id?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  monthly_newsletter?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  registration_type?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  submission_reminder?: Maybe<Scalars['Boolean']>;
};


export type UserEmail_Verified_AtArgs = {
  format?: InputMaybe<Scalars['String']>;
};

export type UserGroup = {
  handle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Contract = {
  AgreementNo?: Maybe<Scalars['String']>;
  CRMid?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  CityPayer?: Maybe<Scalars['String']>;
  EndDate?: Maybe<Scalars['String']>;
  FunctionaLoc_code?: Maybe<Scalars['String']>;
  NAVid?: Maybe<Scalars['String']>;
  Payer_name?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  PostalCodePayer?: Maybe<Scalars['String']>;
  SellTo_name?: Maybe<Scalars['String']>;
  StartDate?: Maybe<Scalars['String']>;
  Status?: Maybe<Scalars['String']>;
  StatusCode?: Maybe<Scalars['String']>;
  Street1?: Maybe<Scalars['String']>;
  StreetPayer?: Maybe<Scalars['String']>;
};

export type Counter = {
  counter_type?: Maybe<Scalars['String']>;
  created_at_month?: Maybe<Scalars['String']>;
  created_at_year?: Maybe<Scalars['String']>;
  full_date?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Counter_Entered = {
  Ending_Counter_Quantity?: Maybe<Scalars['Int']>;
  Posting_Date?: Maybe<Scalars['String']>;
  already_entered?: Maybe<Scalars['Boolean']>;
};

export type Counter_Number = {
  counter_number?: Maybe<Scalars['String']>;
};

export type Counter_Query = {
  items?: Maybe<Array<Maybe<Counter_Query_Attb>>>;
};

export type Counter_Query_Attb = {
  Consumption_Quantity?: Maybe<Scalars['String']>;
  Correction?: Maybe<Scalars['String']>;
  Ending_Counter_Quantity?: Maybe<Scalars['String']>;
  Entry_No?: Maybe<Scalars['String']>;
  Inventory_No?: Maybe<Scalars['String']>;
  Pavsal?: Maybe<Scalars['String']>;
  Popisano_stanje?: Maybe<Scalars['String']>;
  Posting_Date?: Maybe<Scalars['String']>;
  Reported_State?: Maybe<Scalars['String']>;
  Starting_Counter_Quantity?: Maybe<Scalars['String']>;
};

export type Create_Counter = {
  counter_type?: Maybe<Scalars['String']>;
  created_at_month?: Maybe<Scalars['String']>;
  created_at_year?: Maybe<Scalars['String']>;
  full_date?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Create_Place = {
  items?: Maybe<Array<Maybe<Place>>>;
};

export type Create_Task = {
  body?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Edit_Place = {
  CRM_AccountId?: Maybe<Scalars['String']>;
  CRMid?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  NAVid?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Street1?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  counters?: Maybe<Array<Maybe<Counter>>>;
  external_document_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceNotifications?: Maybe<Scalars['Boolean']>;
  recipient_number?: Maybe<Scalars['String']>;
  tax_number?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Global_Admin = {
  end_date_counter?: Maybe<Scalars['String']>;
  start_date_counter?: Maybe<Scalars['String']>;
};

export type Place = {
  CRM_AccountId?: Maybe<Scalars['String']>;
  CRMid?: Maybe<Scalars['String']>;
  City?: Maybe<Scalars['String']>;
  NAVid?: Maybe<Scalars['String']>;
  PostalCode?: Maybe<Scalars['String']>;
  Street1?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  counters?: Maybe<Array<Maybe<Counter>>>;
  external_document_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invoiceNotifications?: Maybe<Scalars['Boolean']>;
  recipient_number?: Maybe<Scalars['String']>;
  tax_number?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Place_Balance = {
  Balance?: Maybe<Scalars['String']>;
};

export type Receipt = {
  items?: Maybe<Array<Maybe<Receipt_Attb>>>;
  total_remaining_amount?: Maybe<Scalars['Float']>;
};

export type Receipt_Attb = {
  Amount?: Maybe<Scalars['String']>;
  Applies_to_Doc_Type?: Maybe<Scalars['String']>;
  Customer_No?: Maybe<Scalars['String']>;
  Description?: Maybe<Scalars['String']>;
  Document_No?: Maybe<Scalars['String']>;
  Document_Type?: Maybe<Scalars['String']>;
  Entry_No?: Maybe<Scalars['String']>;
  FileName?: Maybe<Scalars['String']>;
  Key?: Maybe<Scalars['String']>;
  Open?: Maybe<Scalars['String']>;
  Posting_Date?: Maybe<Scalars['String']>;
  Remaining_Amount?: Maybe<Scalars['String']>;
};

export type Receipt_Pdf = {
  PDF?: Maybe<Scalars['String']>;
};

export type Remove_Place = {
  status?: Maybe<Scalars['String']>;
};

export type Statistics = {
  items?: Maybe<Array<Maybe<Receipt_Attb>>>;
  total_remaining_amount?: Maybe<Scalars['Float']>;
};

export type Task = {
  body?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CreatePlaceQueryVariables = Exact<{
  external_document_number?: InputMaybe<Scalars['String']>;
  recipient_number?: InputMaybe<Scalars['String']>;
  tax_number?: InputMaybe<Scalars['String']>;
}>;


export type CreatePlaceQuery = { create_place?: { items?: Array<{ id?: string | null } | null> | null } | null };

export type CreateTaskQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type CreateTaskQuery = { create_task?: { type?: string | null } | null };

export type EditPLaceQueryVariables = Exact<{
  title?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceNotifications?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditPLaceQuery = { edit_place?: { id?: string | null } | null };

export type FaqQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqQueryQuery = { global_admin?: { questions?: Array<{ question?: string | null, answer?: string | null } | null> | null } | {} | null };

export type FormsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type FormsQueryQuery = { global_admin?: { forms_type?: Array<{ form_name?: string | null, link?: string | null } | null> | null } | {} | null };

export type ContractsQueryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContractsQueryQuery = { entry?: { data?: Array<{ contracts?: Array<{ AgreementNo?: string | null, StartDate?: string | null, EndDate?: string | null, Status?: string | null } | null> | null } | {} | null> | null } | null };

export type CounterEnteredQueryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CounterEnteredQueryQuery = { counter_entered?: { already_entered?: boolean | null, Posting_Date?: string | null, Ending_Counter_Quantity?: number | null } | null };

export type CounterNumberQueryVariables = Exact<{
  place_id?: InputMaybe<Scalars['String']>;
}>;


export type CounterNumberQuery = { counter_number?: { counter_number?: string | null } | null };

export type CountersQueryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CountersQueryQuery = { counter_query?: { items?: Array<{ Entry_No?: string | null, Posting_Date?: string | null, Ending_Counter_Quantity?: string | null, Reported_State?: string | null, Pavsal?: string | null } | null> | null } | null };

export type GetGlobalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGlobalsQuery = { global_admin?: { end_date_counter?: number | null, start_date_counter?: number | null } | {} | null };

export type GetInvoicePdfQueryVariables = Exact<{
  cust_ledger_entry?: InputMaybe<Scalars['String']>;
  place_id?: InputMaybe<Scalars['String']>;
}>;


export type GetInvoicePdfQuery = { receipt_pdf?: { PDF?: string | null } | null };

export type ReceiptAmountQueryVariables = Exact<{
  id: Scalars['String'];
  customer_num: Scalars['String'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type ReceiptAmountQuery = { receipt?: { total_remaining_amount?: number | null } | null };

export type ReceiptQueryVariables = Exact<{
  id: Scalars['String'];
  customer_num: Scalars['String'];
  end_date: Scalars['String'];
  start_date: Scalars['String'];
}>;


export type ReceiptQuery = { receipt?: { items?: Array<{ Key?: string | null, Entry_No?: string | null, Customer_No?: string | null, Posting_Date?: string | null, Document_Type?: string | null, Document_No?: string | null, Description?: string | null, Amount?: string | null, Remaining_Amount?: string | null, Open?: string | null, Applies_to_Doc_Type?: string | null, FileName?: string | null } | null> | null } | null };

export type LastMonthStatisticsQueryQueryVariables = Exact<{
  id: Scalars['String'];
  customer_num: Scalars['String'];
  year: Scalars['String'];
}>;


export type LastMonthStatisticsQueryQuery = { statistics?: { items?: Array<{ Posting_Date?: string | null, Amount?: string | null } | null> | null } | null };

export type GetPlacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlacesQuery = { entry?: { data?: Array<{ id: string, FunctionaLoc_code?: string | null, external_document_number?: string | null, recipient_number?: string | null, tax_number?: string | null, title?: string | null, NAVid?: string | null, Street1?: string | null, City?: string | null, PostalCode?: string | null, CRMid?: string | null, invoiceNotifications?: boolean | null, contracts?: Array<{ Payer_name?: string | null, StreetPayer?: string | null, CityPayer?: string | null, PostalCodePayer?: string | null, SellTo_name?: string | null } | null> | null } | {} | null> | null } | null };

export type StatisticsQueryQueryVariables = Exact<{
  id: Scalars['String'];
  customer_num: Scalars['String'];
  year: Scalars['String'];
}>;


export type StatisticsQueryQuery = { statistics?: { items?: Array<{ Posting_Date?: string | null, Amount?: string | null } | null> | null } | null };

export type GetTranslationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTranslationsQuery = { global_admin?: { privacy_policy?: string | null, cookies?: string | null, terms_and_conditions?: string | null } | {} | null };

export type NewsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsQueryQuery = { entry?: { data?: Array<{ id: string, detail_image?: string | null, news_url?: string | null, title: string, read_more_text?: string | null, date?: string | null } | {} | null> | null } | null };

export type RemovePlaceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type RemovePlaceQuery = { remove_place?: { status?: string | null } | null };

export type ReportCounterQueryVariables = Exact<{
  counter_number?: InputMaybe<Scalars['String']>;
  place_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  counter_type?: InputMaybe<Scalars['String']>;
}>;


export type ReportCounterQuery = { create_counter?: { place_id?: string | null, full_date?: string | null, value?: string | null } | null };


export const CreatePlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreatePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_document_number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipient_number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tax_number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"external_document_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_document_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipient_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipient_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"tax_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tax_number"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePlaceQuery, CreatePlaceQueryVariables>;
export const CreateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CreateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"body"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_task"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"body"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<CreateTaskQuery, CreateTaskQueryVariables>;
export const EditPLaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EditPLace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceNotifications"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edit_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"invoiceNotifications"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceNotifications"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<EditPLaceQuery, EditPLaceQueryVariables>;
export const FaqQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FaqQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_admin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"faq","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalSet_Faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Set_Questions_NovKomplet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FaqQueryQuery, FaqQueryQueryVariables>;
export const FormsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FormsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_admin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"forms","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalSet_Forms"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forms_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Set_FormsType_NovKomplet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_name"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FormsQueryQuery, FormsQueryQueryVariables>;
export const ContractsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContractsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"places","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry_Places_Place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"AgreementNo"}},{"kind":"Field","name":{"kind":"Name","value":"StartDate"}},{"kind":"Field","name":{"kind":"Name","value":"EndDate"}},{"kind":"Field","name":{"kind":"Name","value":"Status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContractsQueryQuery, ContractsQueryQueryVariables>;
export const CounterEnteredQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CounterEnteredQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counter_entered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"already_entered"}},{"kind":"Field","name":{"kind":"Name","value":"Posting_Date"}},{"kind":"Field","name":{"kind":"Name","value":"Ending_Counter_Quantity"}}]}}]}}]} as unknown as DocumentNode<CounterEnteredQueryQuery, CounterEnteredQueryQueryVariables>;
export const CounterNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CounterNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counter_number"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counter_number"}}]}}]}}]} as unknown as DocumentNode<CounterNumberQuery, CounterNumberQueryVariables>;
export const CountersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"counter_query"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Entry_No"}},{"kind":"Field","name":{"kind":"Name","value":"Posting_Date"}},{"kind":"Field","name":{"kind":"Name","value":"Ending_Counter_Quantity"}},{"kind":"Field","name":{"kind":"Name","value":"Reported_State"}},{"kind":"Field","name":{"kind":"Name","value":"Pavsal"}}]}}]}}]}}]} as unknown as DocumentNode<CountersQueryQuery, CountersQueryQueryVariables>;
export const GetGlobalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGlobals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_admin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"admin","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalSet_Admin"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"end_date_counter"}},{"kind":"Field","name":{"kind":"Name","value":"start_date_counter"}}]}}]}}]}}]} as unknown as DocumentNode<GetGlobalsQuery, GetGlobalsQueryVariables>;
export const GetInvoicePdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoicePdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cust_ledger_entry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt_pdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cust_ledger_entry"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cust_ledger_entry"}}},{"kind":"Argument","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PDF"}}]}}]}}]} as unknown as DocumentNode<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>;
export const ReceiptAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReceiptAmount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_num"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_remaining_amount"}}]}}]}}]} as unknown as DocumentNode<ReceiptAmountQuery, ReceiptAmountQueryVariables>;
export const ReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Receipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receipt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_num"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Key"}},{"kind":"Field","name":{"kind":"Name","value":"Entry_No"}},{"kind":"Field","name":{"kind":"Name","value":"Customer_No"}},{"kind":"Field","name":{"kind":"Name","value":"Posting_Date"}},{"kind":"Field","name":{"kind":"Name","value":"Document_Type"}},{"kind":"Field","name":{"kind":"Name","value":"Document_No"}},{"kind":"Field","name":{"kind":"Name","value":"Description"}},{"kind":"Field","name":{"kind":"Name","value":"Amount"}},{"kind":"Field","name":{"kind":"Name","value":"Remaining_Amount"}},{"kind":"Field","name":{"kind":"Name","value":"Open"}},{"kind":"Field","name":{"kind":"Name","value":"Applies_to_Doc_Type"}},{"kind":"Field","name":{"kind":"Name","value":"FileName"}}]}}]}}]}}]} as unknown as DocumentNode<ReceiptQuery, ReceiptQueryVariables>;
export const LastMonthStatisticsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastMonthStatisticsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_num"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}}},{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Posting_Date"}},{"kind":"Field","name":{"kind":"Name","value":"Amount"}}]}}]}}]}}]} as unknown as DocumentNode<LastMonthStatisticsQueryQuery, LastMonthStatisticsQueryQueryVariables>;
export const GetPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"places","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry_Places_Place"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Payer_name"}},{"kind":"Field","name":{"kind":"Name","value":"StreetPayer"}},{"kind":"Field","name":{"kind":"Name","value":"CityPayer"}},{"kind":"Field","name":{"kind":"Name","value":"PostalCodePayer"}},{"kind":"Field","name":{"kind":"Name","value":"SellTo_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"FunctionaLoc_code"}},{"kind":"Field","name":{"kind":"Name","value":"external_document_number"}},{"kind":"Field","name":{"kind":"Name","value":"recipient_number"}},{"kind":"Field","name":{"kind":"Name","value":"tax_number"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"NAVid"}},{"kind":"Field","name":{"kind":"Name","value":"Street1"}},{"kind":"Field","name":{"kind":"Name","value":"City"}},{"kind":"Field","name":{"kind":"Name","value":"PostalCode"}},{"kind":"Field","name":{"kind":"Name","value":"CRMid"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNotifications"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPlacesQuery, GetPlacesQueryVariables>;
export const StatisticsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StatisticsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer_num"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_num"}}},{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Posting_Date"}},{"kind":"Field","name":{"kind":"Name","value":"Amount"}}]}}]}}]}}]} as unknown as DocumentNode<StatisticsQueryQuery, StatisticsQueryQueryVariables>;
export const GetTranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTranslations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"global_admin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"translations","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GlobalSet_Translations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"privacy_policy"}},{"kind":"Field","name":{"kind":"Name","value":"cookies"}},{"kind":"Field","name":{"kind":"Name","value":"terms_and_conditions"}}]}}]}}]}}]} as unknown as DocumentNode<GetTranslationsQuery, GetTranslationsQueryVariables>;
export const NewsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewsQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"news","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"date desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry_News_News"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"detail_image"}},{"kind":"Field","name":{"kind":"Name","value":"news_url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"read_more_text"}},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"d. m. Y","block":false}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<NewsQueryQuery, NewsQueryQueryVariables>;
export const RemovePlaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RemovePlace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remove_place"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<RemovePlaceQuery, RemovePlaceQueryVariables>;
export const ReportCounterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReportCounter"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"counter_number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"counter_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_counter"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"counter_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"counter_number"}}},{"kind":"Argument","name":{"kind":"Name","value":"place_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"place_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}},{"kind":"Argument","name":{"kind":"Name","value":"counter_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"counter_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"full_date"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ReportCounterQuery, ReportCounterQueryVariables>;